import React from "react";
import ReactMarkdown from "react-markdown";
import { resolvePatchNoteImageUrl } from "../utils/patchNotes";

const markdownComponents = {
  img: ({ src, alt }: { src?: string; alt?: string }) => (
    <img
      className="patch-notes-image"
      src={resolvePatchNoteImageUrl(src)}
      alt={alt || ""}
    />
  ),
};

type Props = {
  content: string;
};

export const PatchNoteMarkdown = ({ content }: Props) => (
  <div className="patch-notes-markdown">
    <ReactMarkdown components={markdownComponents}>{content}</ReactMarkdown>
  </div>
);
